import {
    all, takeEvery, select, call, put
} from 'redux-saga/effects';
import * as impactAnalysisSummarySelectors from '../../impactanalysis/summary/selectors';
import * as impactAnalysisDetailedSelectors from '../../impactanalysis/impactdetailed/selectors';
import * as impactAnalysisImpactSummarySelectors from '../../impactanalysis/impactsummary/imimpactsummary/selectors';
import * as csaSummarySelectors from '../../summary/csasummary/selectors';
import * as csaDrilldownSelectors from '../../summary/csadrilldown/selectors';
import * as monitoringSummarySelectors from '../../summary/monitoringSummary/selectors';
import { saveConfiguration } from '../../api/configurationApi';
import { saveConfigurationFailed } from './actions';
import version from './configurationVersion';

let subscriptions = [];

const getSubscription = action => subscriptions.find(s => action.type === s.actionType);

export const subscribeConfiguration = (actionType, pageName) => {
    subscriptions.push({ actionType, pageName });
};

export const unsubscribe = (actionType) => {
    subscriptions = subscriptions.filter(s => s.actionType !== actionType);
};

export function* updateUserConfiguration(action) {
    const subscription = getSubscription(action);
    const { pageName = '' } = subscription;
    switch (pageName) {
        case 'ImpactAnalysis': {
            const currency = yield select(impactAnalysisSummarySelectors.getCurrencyToShow);
            const showCsaSummary = yield select(impactAnalysisSummarySelectors.getShowCsaSummary);
            const showDefaultMappings = yield select(
                impactAnalysisSummarySelectors.getShowDefaultMappings
            );
            const impactDetailedColumns = yield select(impactAnalysisDetailedSelectors.getColumns);
            const impactSummaryColumns = yield select(
                impactAnalysisImpactSummarySelectors.getColumns
            );
            try {
                yield call(saveConfiguration, pageName,
                    {
                        currency,
                        showCsaSummary,
                        showDefaultMappings,
                        impactDetailedColumns,
                        impactSummaryColumns,
                        version
                    });
            } catch (error) {
                yield put(saveConfigurationFailed(error.message));
            }
            break;
        }
        case 'CSASummary': {
            const columns = yield select(csaSummarySelectors.getColumns);
            try {
                yield call(saveConfiguration, pageName, { columns, version });
            } catch (error) {
                yield put(saveConfigurationFailed(error.message));
            }
            break;
        }
        case 'monitoringSummary': {
            const columns = yield select(monitoringSummarySelectors.getColumns);
            try {
                yield call(saveConfiguration, pageName, { columns, version });
            } catch (error) {
                yield put(saveConfigurationFailed(error.message));
            }
            break;
        }
        case 'CSADrilldown': {
            const columns = yield select(csaDrilldownSelectors.getColumns);
            try {
                yield call(saveConfiguration, pageName, { columns, version });
            } catch (error) {
                yield put(saveConfigurationFailed(error.message));
            }
            break;
        }
        default:
            break;
    }
}

export const clearSubscriptions = () => {
    subscriptions = [];
};

export default function* rootSaga() {
    yield all([
        takeEvery(getSubscription, updateUserConfiguration)
    ]);
}
